import fetcher from 'api/fetcher';

import { setIdAdminAction, setLoadCampaignAdminAction } from 'store/models/adminCampaignAction';
import { RemainderBudget, setDataRemainderBudgets, setVisibleRemainderBudgets } from 'store/models/remainderBudgets';
import { AppThunkAction } from 'store/utils';

export const fetchRemainderBudgets = (campaignId: number): AppThunkAction => {
    return async (dispatch) => {
        dispatch([setLoadCampaignAdminAction(true), setIdAdminAction(campaignId)]);
        return fetcher
            .get<unknown, RemainderBudget[]>(`/api/v1/backoffice/info/${campaignId}/remainder`)
            .then((data) => {
                dispatch([setVisibleRemainderBudgets(true), setDataRemainderBudgets(data)]);
            });
    };
};
